<div class="general-container flex flex-col justify-center items-center content-center">
    <!-- Select para los diferentes tipos de participaciones -->
    <div *ngIf="localInvestProject === true && hasEconomicRights" class="invest-content local-invest-content">
        <div class="row local-shared-container">
            <section class="col-6 select-content">
                <h2 class="text-h600 md:text-h800 text-center bg-gradient-2-text">{{ 'local_invest.invest_title' |
                    translate }} {{ data.projectName }}</h2>
                <p class="text-center text-gray-40 text-l pb-24">{{ 'local_invest.invest_subtitle' | translate }}</p>
                <div class="inp" *ngIf="hasSharedList">
                    <fun-input placeholder="{{ 'local_invest.share_type' | translate }}" [parentForm]="sharedForm"
                        [formControlKeys]="formControlKeys" [errorMessages]="errorMessages" [isSubmit]="isSubmit"
                        controlName="shared" type="select" labelName="{{ 'local_invest.share_type' | translate }}"
                        (selectChange)="changeSharedType($event)" [items]="sharedList"
                        [selectedItem]="selectItm"></fun-input>
                </div>
            </section>
            <section class="col-6 info-content">
                <div class="tick_container" *ngIf="hasSharedList">
                    <p>{{ 'local_invest.estimated_prof' | translate }} <span
                            *ngIf="shareInfo.profitability !== undefined">{{ shareInfo.profitability |
                            number:'1.2-2':'es' }}%</span></p>
                    <p>{{ 'local_invest.invest_duration' | translate }} {{ shareInfo.long_description }} {{
                        'local_invest.years' | translate }}</p>
                    <p>{{ 'local_invest.repurchase_option' | translate }} <span *ngIf="shareInfo.repurchase">{{
                            'local_invest.yes' | translate }}</span><span *ngIf="!shareInfo.repurchase">No</span></p>
                    <p>{{ 'MOVEMENTS.NOTICEBOARD' | translate }}: <span *ngIf="shareInfo.can_operate_in_marketplace">{{
                            'local_invest.yes' | translate }}</span><span
                            *ngIf="!shareInfo.can_operate_in_marketplace">No</span></p>
                </div>
            </section>
        </div>
    </div>
    <!---->
    <div *ngIf="localInvestProject !== true"
        class="invest-content max-w-full md:max-w-[1200px] mx-auto py-20 md:pt-[75px] md:pb-[50px]">
        <!-- <h2 class="text-h600 md:text-h800 text-center bg-gradient-2-text" *ngIf="data.status !== 14">{{ 'invest.Process.Title' | translate }}</h2> -->
        <h2 class="text-h600 md:text-h800 text-center bg-gradient-2-text" *ngIf="data.status === 14">{{
            'OVERVIEW.CAPITAL_INCREASE.TITLE' | translate }}</h2>
        <fun-info *ngIf="hasReservedMoney" [data]="infoReserveData" (clickBtnEvent)="invest()"></fun-info>
        <p class="increase" *ngIf="data.status === 14"
            innerHTML="{{ 'OVERVIEW.CAPITAL_INCREASE.INCREASE_TEXT' | translate: { amount: data.max_allowed_amount_to_invest_for_user } }}">
        </p>
        <form class="md:grid md:grid-cols-2 gap-x-24" [formGroup]="cashForm" (submit)="invest()">
            <div class="pay-info">
                <p class="block text-eggplant-80 text-l mb-[6px]">Tu inversión</p>
                <div class="rounded rounded-xl bg-gray-10/[0.1] p-24 border border-eggplant-100/[0.1] mb-12">
                    <p class="text-gray-40 text-m pb-2" *ngIf="data.status !== 14">{{ 'invest.text' | translate }}
                        <span *ngIf="this.data.allowedAmountModules !== '' ">{{ 'invest.allow' | translate }} </span>
                        <span class="bolder" *ngIf="this.data.allowedAmountModules !== '' "> {{
                            this.data.allowedAmountModules }}</span>
                    </p>
                    <p class="text-gray-40 text-m pb-2" *ngIf="minInvestmentAllowed > 0">{{ 'INVEST.INVEST_MIN_ALLOWED'
                        | translate }}
                        <span class="text-orange-100"> {{ minInvestmentAllowed + 1 }}€</span>
                    </p>
                    <div *ngIf="(profile.isExperiencedInvestor === null || showAdvice) && !hasToBookInvestment"
                        class="w-full hidden md:flex justify-center gap-8">
                        <fun-icon [name]="'info'"
                            [style]="'w-12 h-12 stroke-[2px] stroke-eggplant-100/[0.5] pt-12'"></fun-icon>
                        <p class="text-m text-eggplant-100/[0.5]"
                            *ngIf="profile.isExperiencedInvestor !== null && showAdvice">{{ 'INVEST.CAPITAL' | translate
                            }}</p>
                        <p class="text-m text-eggplant-100/[0.5]" *ngIf="profile.isExperiencedInvestor === null">{{
                            'INVEST.RISK' | translate }}</p>
                    </div>
                    <div class="amount">
                        <!--pattern="\d*,?\d*?" en un input tipo text-->
                        <fun-input placeholder="0 €" [parentForm]="cashForm" [formControlKeys]="formControlKeys"
                            [errorMessages]="errorMessages" [isSubmit]="isSubmit" controlName="cash" type="invest"
                            [errorLogin]="errorCash" labelName="{{ 'local_invest.cap_to_invest' | translate }} "
                            [value]="amount" (keyup)="sendValue(); checkPromotionalCode();" #inputAmount></fun-input>
                        <!-- Mensaje para grupos CON investObjective -->
                        <div *ngIf="priorityGroupForUser?.investObjective != null && priorityGroupForUser?.investObjective > 0"
                            class="flex flex-row items-center gap-6 mt-8 px-10 py-6 rounded-xl bg-eggplant-100/[0.05] border border-eggplant-100/[0.2] w-fit">
                            <fun-icon [name]="'info-circle'"
                                [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100 flex-shrink-0'"></fun-icon>
                            <p class="font-sans text-s text-eggplant-70 leading-[1.3]">Tu grupo prioritario ha invertido
                                {{ priorityGroupForUser.contributedAmount | number:'1.0-0':'es' }}€ de los {{
                                priorityGroupForUser.investObjective | number:'1.0-0':'es' }}€ que tiene reservados.</p>
                        </div>
                        <div class="co2">
                            <span class="text-s text-gray-40">{{ 'invest.Process.avoid' | translate }}</span>
                            <h3 class="text-eggplant-80 text-l" *ngIf="!moreTanAvailable">{{ prevent | co2 }}</h3>
                            <h3 class="text-eggplant-80 text-l" *ngIf="moreTanAvailable">-</h3>
                        </div>
                        <div class="promotional_money_content flex" *ngIf="promotionalMoney > 0">
                            <div class="">
                                <ion-toggle [checked]="addPromoChecked"
                                    (ionChange)="checkAddPromo(); calculate();"></ion-toggle>
                            </div>
                            <p class="text-m text-eggplant-100/[0.4] relative pl-12"
                                [ngClass]="{'checked': addPromoChecked }">{{ 'INVEST.INVEST' | translate }} {{
                                promotionalMoney | number:'1.0-0':'es' }}€ {{ 'INVEST.PROMO_AVAILABLE' | translate }}
                                <span
                                    *ngIf="addPromoChecked && cashForm.value.cash !== '' && cashForm.value.cash !== '0' ">{{
                                    'INVEST.TOTAL_TO_INVEST' | translate }} {{ totalMoney | number:'1.0-0':'es'
                                    }}€</span>
                            </p>
                        </div>
                        <div *ngIf="errorMaxAmount" class="error_amount_msg">
                            <p>{{ 'OVERVIEW.CAPITAL_INCREASE.LIMIT_INCREASE' | translate }} {{
                                data.max_allowed_amount_to_invest_for_user }}€</p>
                        </div>
                        <!-- Check de caso especial como Porfolio Delta de Electra Caldense -->
                        <div class="flex pt-12" *ngIf="currentProjectHasEmployeeAndClientInvestmentPhase">
                            <div class="">
                                <ion-toggle [checked]="currentProjectHasEmployeeAndClientInvestmentPhaseChecked"
                                    (ionChange)="checkCurrentProjectHasEmployeeAndClientInvestmentPhaseChecked()"></ion-toggle>
                            </div>
                            <p class="text-m text-eggplant-100/[0.55] relative pl-12">{{
                                getCurrentProjectHasEmployeeAndClientInvestmentPhaseText() }}</p>
                        </div>
                    </div>
                    <div *ngIf="isForeingInvestor && data['id'] === 161" class="error_amount_msg">
                        <p>{{ 'INVEST.NO_FOREIGN_ALLOWED' | translate }}</p>
                    </div>
                    <div *ngIf="showStatkaftAdvise" class="error_amount_msg">
                        <p>{{ 'INVEST.STATKRAFT_ADVISE' | translate }}</p>
                    </div>
                </div>
                <div class="advise md:hidden"
                    *ngIf="(profile.isExperiencedInvestor === null || showAdvice) && !hasToBookInvestment">
                    <p class="text-s text-gray-40" *ngIf="profile.isExperiencedInvestor === null">{{ 'INVEST.RISK' |
                        translate }}</p>
                    <p class="text-s text-gray-40" *ngIf="profile.isExperiencedInvestor !== null && showAdvice">{{
                        'INVEST.CAPITAL' | translate }}</p>
                </div>
                <div class="code" [ngClass]="{'ref_code_included': hasReferredCode }">
                    <p class="pb-6 text-l text-eggplant-80" (click)="openCode()">{{
                        'invest.Process.Code' | translate
                        }}<span> {{ symbol }} </span></p>
                    <fun-input *ngIf="isOpen" placeholder="{{ 'INVEST.INTRODUCE_YOUR_CODE' | translate }}"
                        [parentForm]="cashForm" [formControlKeys]="formControlKeys" [errorMessages]="errorMessages"
                        [isSubmit]="isSubmit" controlName="promotion" type="text" [value]="promoCode"
                        [errorLogin]="errorCash" (keyup)="checkPromotionalCode()"
                        (pasate)="checkPromotionalCode()"></fun-input>
                    <!-- <p *ngIf="hasReferredCode" class="text-l text-gray-40">{{ 'local_invest.ref_code' | translate }}</p> -->
                    <p *ngIf="refMessage" class="text-l bg-gradient-2-text">{{ refMessage }}</p>
                </div>
            </div>
            <div class="pay-mode" *ngIf="!isInvestCommitment && !hasToBookInvestment">
                <div class="mb-[6px]">
                    <span class="block text-eggplant-80 text-l">{{ 'invest.Process.pay' | translate }}</span>
                </div>
                <div class="flex flex-col gap-y-12 methods">
                    <!-- Aviso de tarjeta -->
                    <div class="method">
                        <fun-badge-group [props]="badgeGroupCreditCard"></fun-badge-group>
                    </div>
                    <!-- Transferencia -->
                    <div *ngIf="!enablePayByCardMethod" class="method">
                        <div class="panel panel-default cursor-pointer flex px-24 py-16 no-checked-card bg-sepa">
                            <div class="flex flex-col md:flex-row md:gap-24">
                                <!-- Columna izquierda -->
                                <div class="flex flex-col md:w-full">
                                    <!-- Header con badge -->
                                    <div class="flex flex-col md:flex-row items-start gap-8 mb-12">
                                        <p class="bg-alert font-sans px-10 py-2 rounded-xl text-s text-white w-fit">
                                            ¡NOVEDAD!</p>
                                        <h3 class="text-eggplant-100 text-l font-sans">{{ 'INVEST.SEPA_TITLE' |
                                            translate }}</h3>
                                    </div>
                                    <p class="text-eggplant-70 text-m pb-0 md:pb-12">{{ 'INVEST.OPTIMIZED_SYSTEM' |
                                        translate }}</p>
                                    <ul class="space-y-6 mt-24 md:mt-0 w-full">
                                        <li class="flex gap-8">
                                            <fun-icon [name]="'check-circle'"
                                                [style]="'w-20 h-20 stroke-[2px] stroke-[#EC4899] pt-2'"></fun-icon>
                                            <span class="text-eggplant-80 text-m">{{ 'INVEST.INSTANT_TRANSFERS' |
                                                translate }}</span>
                                        </li>
                                        <li class="flex gap-8">
                                            <fun-icon [name]="'check-circle'"
                                                [style]="'w-20 h-20 stroke-[2px] stroke-[#EC4899] pt-2'"></fun-icon>
                                            <span class="text-eggplant-80 text-m">{{ 'INVEST.MORE_SECURITY' | translate
                                                }}</span>
                                        </li>
                                        <!-- <li class="flex gap-8">
                                        <fun-icon [name]="'check-circle'" [style]="'w-20 h-20 stroke-[2px] stroke-[#EC4899]'"></fun-icon>
                                        <span class="text-eggplant-80 text-m">{{ 'INVEST.NO_LIMITS' | translate }}</span>
                                    </li> -->
                                    </ul>

                                    <!-- Botón de acción -->
                                    <div class="flex justify-center pt-12 gap-4 justify-center items-center">
                                        <p class="text-l cursor-pointer text-orange-100 underline underline-offset-2 "
                                            (click)="checkMyIban()">{{ 'INVEST.SEE_IBAN' | translate }}</p>
                                        <fun-icon [name]="'eye'"
                                            [style]="'w-20 h-20 stroke-[2px] stroke-orange-100'"></fun-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- hasta aqui-->
                    <div *ngIf="enablePayByCardMethod" class="method first">
                        <label>
                            <input type="radio" class="card-input-element" name="stockPackageId" id="pm-tdc" value="1"
                                formControlName="stockPackageId" (click)="setTypeForm(1)" />
                            <div class="panel panel-default cursor-pointer flex"
                                [ngClass]="{'checked-card': method === 1, 'no-checked-card': method !== 1 }">
                                <div class="px-24 py-16 w-full">
                                    <p class="text-eggplant-80 text-l md:text-xl text-left">{{ 'invest.Process.card' |
                                        translate }}</p>
                                    <h4 class="text-left text-m md:text-l text-gray-40 w-fit whitespace-nowrap">{{
                                        'invest.Process.max' | translate }}</h4>
                                </div>
                                <div class="flex items-center justify-center pr-24">
                                    <img src="../../../../../assets/images/invest/visa-mastercard.svg" alt="">
                                </div>
                            </div>
                        </label>
                    </div>
                    <div *ngIf="data.hasWallet" class="method second">
                        <label>
                            <input type="radio" class="card-input-element" name="stockPackageId" id="pm-wallet"
                                value="2" formControlName="stockPackageId" (click)="setTypeForm(2)" />
                            <div class="panel panel-default cursor-pointer flex"
                                [ngClass]="{'checked-card': method === 2,'no-checked-card': method !== 2 }">
                                <div class="px-24 py-16 w-full">
                                    <p class="text-eggplant-80 text-l md:text-xl text-left">{{ 'invest.Process.Fundeen'
                                        | translate }}</p>
                                    <h4 class="text-left text-m md:text-l text-gray-40 w-fit whitespace-nowrap">{{
                                        'invest.Process.available' | translate }} {{ data.moneyOutBalance -
                                        data.blockedMoney | number:'1.0-2':'es' }} €</h4>
                                </div>
                                <div class="flex items-center justify-center pr-24">
                                    <img src="../../../../../assets/images/invest/fundeen-payment.svg" alt="">
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="hasToBookInvestment">
                <div class="mb-[6px]">
                    <span class="block text-eggplant-80 text-l">
                        {{ currentStage?.type === 1 ? '¡Reserva tu participación!' : 'Inversión en Fase Prioritaria' }}
                    </span>
                </div>
                <div class="flex flex-col gap-y-12 methods md:min-h-[380px]">
                    <div
                        class="flex flex-col px-24 py-16 rounded rounded-xl bg-gray-10/[0.1] border border-eggplant-100/[0.1]">
                        <!-- Mensaje para forceReservationMode (grupo prioritario lleno sin otro grupo) -->
                        <!-- <ng-container>
                            <p class="text-gray-40 text-m pb-12">
                                Como tu grupo prioritario ha cubierto todo su objetivo y no perteneces a otro grupo
                                prioritario, no puedes invertir en esta fase.
                            </p>
                            <p class="text-gray-40 text-m">
                                Aprovecha y reserva tu inversión para cuando puedas hacerlo en la fase global.
                            </p>
                        </ng-container> -->
                        <!-- Mensaje para type === 1 (fase de reservas) -->
                        <ng-container *ngIf="currentStage?.type === 1">
                            <p class="text-gray-40 text-m pb-12">
                                {{ 'INVEST.CURRENTLY_RESERVE_STAGE' | translate }}
                            </p>
                            <p class="text-gray-40 text-m">
                                {{ 'INVEST.MAIL_WHEN_CAN_FORMALIZE' | translate }}
                            </p>
                        </ng-container>
                        <!-- Mensaje para type !== 1 (fase prioritaria sin grupo) -->
                        <ng-container *ngIf="currentStage?.type !== 1">
                            <p class="text-gray-40 text-m pb-12">
                                {{ 'INVEST.ONLY_PRIORITY_INVESTORS' | translate }}
                            </p>
                            <!-- <p class="text-gray-40 text-m pb-12">
                                Reserva tu plaza: Te daremos prioridad de entrada en cuanto se abra la fase pública.
                            </p> -->
                            <div *ngIf="investmentMockTextGroups && investmentMockTextGroups.title"
                                class="flex flex-col gap-6 mt-8 px-10 py-6 md:p-16 rounded-xl bg-eggplant-100/[0.05] border border-eggplant-100/[0.2]">
                                <div class="flex flex-row items-center gap-6">
                                    <fun-icon [name]="'info-circle'"
                                        [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100 flex-shrink-0'"></fun-icon>
                                    <p class="font-sans text-m text-eggplant-100">{{investmentMockTextGroups.title}}</p>
                                </div>
                                <div>
                                    <p class="font-sans text-s  text-eggplant-80">{{investmentMockTextGroups.text}}</p>
                                </div>
                            </div>
                        </ng-container>
                        <h4 class="text-left text-m md:text-l text-gray-40 w-fit whitespace-nowrap pt-12">{{
                            'invest.Process.available' | translate }} {{ data.moneyOutBalance -
                            data.blockedMoney | number:'1.0-2':'es' }} €</h4>
                        <div class="flex justify-center pt-12 gap-4 justify-center items-center" *ngIf="!hiddeIbanLink">
                            <p class="text-l cursor-pointer text-orange-100 underline underline-offset-2 "
                                (click)="checkMyIban()">{{ 'INVEST.SEE_IBAN' | translate }}</p>
                            <fun-icon [name]="'eye'" [style]="'w-20 h-20 stroke-[2px] stroke-orange-100'"></fun-icon>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <!-- <div *ngIf="profile.isExperiencedInvestor === null || showAdvice" class="w-full hidden md:flex items-center justify-center gap-8 mt-24 border border-gray-10 rounded-2xl px-20 py-10">
        <fun-icon [name]="'info-circle'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100/[0.5]'"></fun-icon>
        <p class="text-m text-eggplant-100/[0.5] text-center" *ngIf="profile.isExperiencedInvestor !== null && showAdvice">{{ 'INVEST.CAPITAL' | translate }}</p>
        <p class="text-m text-eggplant-100/[0.5] text-center" *ngIf="profile.isExperiencedInvestor === null">{{ 'INVEST.RISK' | translate }}
            <span class="text-orange-100 cursor-pointer" *ngIf="profile.dontRequestInvestmentExperienceInfo !== true" (click)="openTest()">{{ 'INVESTMENT_RESERVATION.READ_MORE' | translate }}</span>
        </p>
      </div> -->
    </div>
</div>
<div class="button-container flex py-48 md:pt-24 md:pb-0 md:px-40 md:flex-row md:border-t md:border-eggplant-10"
    [ngClass]="{'justify-end': (!hasSharedType || localInvestProject), 'justify-between': (hasSharedType && !localInvestProject) }">
    <div *ngIf="hasSharedType && !localInvestProject" class="prev">
        <fun-new-button size="xl" (eventClick)="prev()" icon="arrow-left" [iconPosition]="'left'" [buttonType]="'ghost'"
            title="{{ 'local_invest.go_back' | translate }}" [responsive]="false"></fun-new-button>
    </div>
    <div class="next" [ngClass]="{'w-full md:w-auto': (!hasSharedType || localInvestProject) }">
        <fun-new-button size="xl" (eventClick)="invest()" class="next-btn" [classExtra]="' !w-full '"
            [buttonType]="sendXHR" title="{{ 'AUTOINVEST.FOOTER.NEXT' | translate }}"
            [responsive]="false"></fun-new-button>
    </div>
</div>